import connect from "../../../shared/data-store/connect";
import { store } from "./DataStore";

customElements.define(
	"esc-hotel-list-progress-bar",
	class extends connect(HTMLElement, store) {
		update(
			{ hotelsOfferable, hotelsNonOfferable, hotelsLoading },
			{ isLoading },
		) {
			const numLoaded = hotelsOfferable.length + hotelsNonOfferable.length,
				numTotal = hotelsLoading.length + numLoaded,
				percent = (numLoaded / numTotal) * 100;

			this.setAttribute("data-ready", isLoading ? "no" : "yes");
			this.style.width = percent + "vw";
		}
	},
);
